import wrapRoot from './src/shared/wrapRoot';
import { isBrowser } from './src/shared/Utils';
export const wrapRootElement = wrapRoot;

// gatsby-browser api which influences scrolling behavior when navigating
export const shouldUpdateScroll = ({
    routerProps: { location },
    getSavedScrollPosition,
    prevRouterProps,
    routerProps,
}) => {
    if (location.state && location.state.preventScroll === true) {
        return false;
    }
    return new Promise(() => {
        if (isBrowser) {
            let hashedElement = null;
            const currentPosition = getSavedScrollPosition(
                location,
                location.key
            );
            const top = currentPosition ? currentPosition[1] : 0;
            if (location.hash) {
                hashedElement = document.querySelector(`${location.hash}`);
            }
            setTimeout(() => {
                requestAnimationFrame(() => {
                    try {
                        hashedElement?.scrollIntoView({
                            behavior: `smooth`,
                            block: `start`,
                        });
                    } catch (e) {
                        document.documentElement?.scrollTo({
                            top: top,
                            left: 0,
                            behavior: `smooth`,
                        });
                    }
                });
            }, 0);
            return true;
        }
    });
};
